import { featCard } from '@/commonTypes';
import React from 'react';
import styles from './styles.module.css';
import UserAvatar from '@/components/pages/profile/ProfileContent/AccountHero/UserInfo/UserAvatar';

export default function TeamCard({ item, index }: { item?: featCard; index?: number }) {
  return (
    <div className={`card ${styles.card}`}>
      <UserAvatar name={item?.name} colorNumber={index} avatarClass={`${styles.avatarClass}`} />
      <div>
        <div className={`${styles.name}`}>{item?.name}</div>
        <div className={`${styles.role}`}>{item?.role}</div>
      </div>
    </div>
  );
}
